import React from 'react';
interface CharacterCounterDisplayProps {
    value: string;
    maxLength: number;
}

const CharacterCounterDisplay: React.FC<CharacterCounterDisplayProps> = ({
    value,
    maxLength,
}) => {
    const currentLength = value ? value.length : 0;
    const isOverLimit = currentLength >= maxLength;
    return (
        <div className="text-right text-sm">
            <span className={`${isOverLimit ? 'text-danger-500' :
                'text-neutral-500'}`}>
                {currentLength}/{maxLength}{" "}
                {/* {isOverLimit && ''} */}
            </span>
        </div>
    );
};
export default CharacterCounterDisplay;